<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
  >
    <v-container class="print-auditlog-info-container">
      <v-layout column class="ch-auditlog-info-component">
        <v-flex xs6>
          <v-card>
            <v-card-text class="body-form auditlog-info-field-border">
              <v-layout column class="ch-info-field-wrapper ma-0 pb-3">
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Event Date & Time</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="time"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Hotel</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="hotel_name"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Operator Name</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="actor_name"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Operator Email</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="actor_email"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Event Type</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="action"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Location</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="location"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Application</span>
                    </div>
                    <div class="ch-info-field-body">
                      <v-text-field
                        class="pt-0"
                        v-model="consumer"
                        readonly
                      ></v-text-field>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <div class="ch-info-field">
                    <div class="ch-info-field-title">
                      <span class="ml-2">Data</span>
                    </div>
                    <div class="ch-info-field-body">
                      <div v-if="before_data !== null">
                        before: <pre>{{ before_data }}</pre>
                        after: <pre>{{ after_data }}</pre>
                      </div>
                      <pre v-else>{{ after_data }}</pre>
                    </div>
                  </div>
                </v-flex>                                                        
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <div class="btn-wrapper">
                <button
                  class="save"
                  v-print
                >
                  <i class="fas fa-print fa-fw"></i>
                  <span>PRINT</span>
                </button>
                <button
                  class="delete"
                  @click="closeDialog"
                >
                  <i class="fas fa-times-circle fa-fw"></i>
                  <span>CANCEL</span>
                </button>
              </div>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
  import { auditLogsEventBus } from '@/components/admin/auditLogs/auditLogsEventBus';
  import _ from 'lodash';
  import Vue from 'vue';
  import Print from 'vue-print-nb';
  import api from '../../../api';

  Vue.use(Print);

  export default {
    data() {
      return {
        dialog: false,
        id: null,
        time: null,
        hotel_name: null,
        actor_name: null,
        actor_email: null,
        action: null,
        target: null,
        location: null,
        consumer: null,
        before_data: null,
        after_data: null,
      };
    },
    methods: {
      getAuditLogDetail() {
        api.getAuditLogDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            console.log('result: ', result.data);
            Object.assign(this, result.data);
            this.time = this.$moment(result.data.time).format('YYYY-MM-DD HH:mm:ss');
            this.hotel_name = result.data.hotel ? result.data.hotel.hotel_name : null;
            this.actor_name = result.data.actor.actor_name;
            this.actor_email = result.data.actor.actor_email;
            if (result.data.before_data && _.isString(result.data.before_data)) {
              this.before_data = JSON.parse(result.data.before_data);
            }
            if (_.isString(result.data.after_data)) {
              this.after_data = JSON.parse(result.data.after_data);
            }
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'auditLogs' });
          }
        });
      },
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
      },
    },
    mounted() {
      auditLogsEventBus.$on('openDialog', () => {
        this.id = this.$route.params.id;
        console.info('openDialog');
        this.openDialog();
        this.getAuditLogDetail();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/auditLogs/AuditLogPrintView.vue